import { isUrlParamEquals, urlHasParam } from '@pb/utils'

import appSelectors from 'App/duck/selectors'

export const getHubState = (state): any => state.account.hub

export const getShouldShowClubJoinMessage = (state): any =>
  !!(
    appSelectors.getIsUserOldAccountHolder(state) &&
    appSelectors.getIsClubMarket(state) &&
    appSelectors.getHasUserLoaded(state)
  )

export const getShouldFetchClubJoinBanner = (state): any =>
  Object.keys(getHubState(state).clubJoinBanner).length <= 0

export const getShowJoinClubModal = (state): any => getHubState(state).showJoinClubModal
export const getIsClubJoinBannerLoading = (state): any => getHubState(state).isClubJoinBannerLoading

export const getShouldShowJoinedClubConfirmationNotification = (): any =>
  isUrlParamEquals('joinedClub', 'true')

export const getShouldShowPayLaterActivationBanner = (state): any =>
  appSelectors.getIsPayLaterActivationAllowed(state) &&
  appSelectors.getIsPayLaterNotActivatedForUser(state)

export const getShouldShowPayLaterConfirmationNotification = (): any =>
  isUrlParamEquals('klarnaOptedIn', 'true')

export const getShouldShowPayLaterActivationPage = (state): boolean =>
  appSelectors.getIsPayLaterActivationAllowed(state) &&
  appSelectors.getIsPayLaterNotActivatedForUser(state) &&
  urlHasParam('showOptIn') &&
  isUrlParamEquals('showOptIn', 'true')
